import Grid from "@components/Grid/Grid";
import Link from "@components/Link/Link";
import { GeneralLink } from "@customTypes/generalLink";
import { PROFILE_PAGE_ANCHOR } from "@utilities/e2e/e2eAnchorsList";
import { getE2EAnchorAttribute } from "@utilities/e2e/getE2EAnchor";
import RenderComponents from "@utilities/renderComponents";
import clsx from "clsx";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { EDIT_PROFILE_SUCCESS_MESSAGE } from "../../constants/index";
import styles from "./MyProfileTabItems.module.scss";

interface MyProfileTabItemsProps {
  myProfileTabItem: {
    fields: {
      tabItem: GeneralLink;
      tabContent?: unknown[];
    };
  }[];
}

export const MyProfileTabItems = (props: {
  content: MyProfileTabItemsProps;
}) => {
  const { query } = useRouter();
  const pageUrl = query.slug || [];

  const { content } = props;
  const { myProfileTabItem } = content;
  const activeIndex = myProfileTabItem.find(
    ({
      fields: {
        tabItem: {
          fields: { url },
        },
      },
    }) => url === `/${pageUrl[0]}`
  );

  const isWindow = typeof window === "object";
  const urlParams = isWindow
    ? new URLSearchParams(window.location.search)
    : null;
  const isDetailsUpdated = urlParams?.get("updated") === "true";

  const [announcement, setAnnouncement] = useState("");

  useEffect(() => {
    if (
      isDetailsUpdated &&
      activeIndex.fields.tabItem.fields.url === "/my-profile"
    ) {
      setAnnouncement(EDIT_PROFILE_SUCCESS_MESSAGE);
    }
  }, [isDetailsUpdated, activeIndex.fields.tabItem.fields.url]);

  return (
    <div className="wrapper">
      <section
        className={clsx(
          "component",
          styles.tabs,
          styles["tabs--my-profile"],
          styles["js-tabs"],
          "cf"
        )}
      >
        <Grid row>
          <Grid column sm={12} md={8}>
            <ul className={styles["js-tablist"]} data-hx="h2">
              {myProfileTabItem.map(
                (
                  {
                    fields: {
                      tabItem: {
                        fields: { linkText, url },
                      },
                    },
                  },
                  i
                ) => (
                  <li key={`${url}${i}`} className={styles["js-tablist-item"]}>
                    <Link
                      href={url || "#"}
                      className={clsx(
                        styles["js-tablist-link"],
                        styles["tabs-link"]
                      )}
                      aria-selected={
                        url === `/${pageUrl[0]}` ? "true" : "false"
                      }
                      {...getE2EAnchorAttribute(
                        PROFILE_PAGE_ANCHOR,
                        `${url}-tab`
                      )}
                    >
                      {linkText}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </Grid>
        </Grid>
        <div className={styles["js-tabcontent"]}>
          <div role="status" aria-atomic="true" className="sr-only">
            {announcement}
          </div>

          {activeIndex && RenderComponents(activeIndex.fields.tabContent)}
        </div>
      </section>
    </div>
  );
};

export default MyProfileTabItems;
